import { get } from 'lodash-es';
import {
  EXTERIOR_SHOT_TYPES,
  INTERIOR_SHOT_TYPES,
  ALL_PHOTOS_TAB_GROUP,
  EXTERIOR_PHOTOS_TAB_GROUP,
  INTERIOR_PHOTOS_TAB_GROUP,
} from 'site-modules/shared/constants/photoflipper/photoflipper';
import { EventToolbox } from 'client/utils/event-toolbox';
import { CAROUSEL_EVENTS } from 'site-modules/shared/components/carousel/events';

export function fireCarouselTracking({
  target,
  currentSlide,
  nextSlide,
  total,
  contentType = 'photo',
  contentDetails = 'content',
  photoType = '',
  actionCause,
}) {
  EventToolbox.fireCustomEvent(CAROUSEL_EVENTS.SWIPE, {
    target,
    data: {
      currentSlide,
      nextSlide,
      total,
      contentType,
      contentDetails,
      photoType,
      actionCause,
    },
  });
}

export function handleThumbnailCarouselClick(
  { event, skipTracking, currentSlide, total, contentType = 'photo', contentDetails = 'thumbnails', photoType = '' },
  callback
) {
  const slideElement = event.target.closest('[data-slide-index]');
  const slideIndex = slideElement && slideElement.dataset.slideIndex;
  if (slideIndex) {
    const nextSlide = parseInt(slideIndex, 10);
    if (!skipTracking) {
      fireCarouselTracking({
        target: event.target.closest('.slick-carousel'),
        currentSlide,
        nextSlide,
        total,
        contentType,
        contentDetails,
        photoType,
        actionCause: 'click',
      });
    }
    if (callback) {
      callback(nextSlide);
    }
  }
}

const getPhotoGroup = photo => {
  const { shotType } = photo;
  const shotTypeProbability = get(photo, 'imageRecognitionData.shotTypeProbability', 0);

  if (shotTypeProbability < 0.5) {
    return ALL_PHOTOS_TAB_GROUP;
  }

  if (EXTERIOR_SHOT_TYPES.includes(shotType)) {
    return EXTERIOR_PHOTOS_TAB_GROUP;
  }

  if (INTERIOR_SHOT_TYPES.includes(shotType)) {
    return INTERIOR_PHOTOS_TAB_GROUP;
  }

  return ALL_PHOTOS_TAB_GROUP;
};

export const fillInPhotoGroups = photoUrls =>
  photoUrls.map(photoUrl => ({
    ...photoUrl,
    group: getPhotoGroup(photoUrl),
  }));

export const hasPhotoForSpecifiedGroup = ({ photoUrls, group }) => photoUrls.find(photoUrl => photoUrl.group === group);
